import { ReactNode } from 'react';
import styled, { css } from 'styled-components';

import { theme } from 'coreOld/themes';

type ScrollableProps = {
  isScrollable?: boolean;
  isLoading?: boolean;
  hasBigHeader?: boolean;
  hasBigSubheader?: boolean;
  hasFilters?: boolean;
  hasFooter?: boolean;
  bodyHeightAuto?: boolean;
  children?: ReactNode;
  id?: string;
};

const calculateHeight = ({
  hasBigHeader = true,
  hasBigSubheader = false,
  hasFilters = true,
  hasFooter = false,
  bodyHeightAuto = false,
}: ScrollableProps) => {
  if (bodyHeightAuto) {
    return 'auto';
  }

  const fixedHeaderWithSubHeaderHeight = hasBigSubheader
    ? theme.topFixedHeaderWithBigSubHeaderHeight
    : theme.topFixedHeaderWithSubHeaderHeight;

  if (hasBigHeader && hasFilters && hasFooter) {
    return `calc(100vh - ${fixedHeaderWithSubHeaderHeight}px - ${theme.filterBarHeight}px -
      2 * ${theme.headerFooterTableHeight}px)`;
  }
  if (hasBigHeader && hasFilters) {
    return `calc(100vh - ${fixedHeaderWithSubHeaderHeight}px - ${theme.filterBarHeight}px)`;
  }
  if (hasBigHeader) {
    return `calc(100vh - ${fixedHeaderWithSubHeaderHeight}px)`;
  }

  return '100vh';
};

const ScrollableView = styled.div<ScrollableProps>`
  position: relative;

  ${({ isScrollable }) =>
    isScrollable &&
    css`
      overflow: auto;
      height: ${(props: ScrollableProps) => calculateHeight(props)};
    `}

  ${({ isLoading }) =>
    isLoading &&
    css`
      div.infinite-scroll-component__outerdiv {
        height: 100%;
      }
    `}
`;

export default ScrollableView;
